import React, { useState } from 'react';
import { Star, Heart, MessageSquare, CheckCircle2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const ALL_REVIEWS = [{
  user: '@lucia_radiestesia_88',
  text: 'Increíble el material, ya estoy usando los gráficos editables con mi péndulo.',
  likes: 12,
  time: '2 horas'
}, {
  user: '@marcos_holistico',
  text: 'Los protocolos de diagnóstico son lo que me faltaba. Gracias!',
  likes: 8,
  time: '4 horas'
}, {
  user: '@ana_sanacion',
  text: 'Muy completo todo, las imágenes de los biómetros están bárbaras.',
  likes: 15,
  time: '6 horas'
}, {
  user: '@terapeuta_luz',
  text: 'La precisión en las mediciones es de otro planeta. Mis pacientes lo notan.',
  likes: 21,
  time: '8 horas'
}, {
  user: '@radiestesia_master_arg',
  text: 'Por fin algo profesional y bien organizado. Vale cada centavo.',
  likes: 34,
  time: '12 horas'
}, {
  user: '@sofi_energia',
  text: 'El mapa de bloqueos me voló la cabeza. Muy recomendado.',
  likes: 19,
  time: '1 día'
}, {
  user: '@pablo_zen',
  text: 'Excelente soporte y el material es de primera calidad.',
  likes: 7,
  time: '1 día'
}, {
  user: '@caro_holistica',
  text: 'Me sirvió mucho para mis sesiones de limpieza de espacios.',
  likes: 11,
  time: '2 días'
}, {
  user: '@espacio_alma',
  text: 'Las fichas de Canva son súper fáciles de editar. Muy práctico.',
  likes: 25,
  time: '2 días'
}, {
  user: '@juan_radiestesia',
  text: 'Un antes y un después en mi práctica profesional con el péndulo.',
  likes: 42,
  time: '3 días'
}, {
  user: '@marta_sanadora',
  text: 'Lo compré ayer y ya devoré la mitad del material. Genial!',
  likes: 14,
  time: '3 días'
}, {
  user: '@vibrando_alto',
  text: 'La protección energética es clave, me cambió la vida.',
  likes: 28,
  time: '4 días'
}, {
  user: '@luz_interior',
  text: 'Muy agradecida por compartir este conocimiento tan valioso.',
  likes: 16,
  time: '4 días'
}, {
  user: '@terapias_bsas',
  text: 'El kit más completo que vi en mucho tiempo. Felicitaciones!',
  likes: 31,
  time: '5 días'
}, {
  user: '@ser_consciente',
  text: 'Las guías de post-sesión son un plus increíble.',
  likes: 9,
  time: '5 días'
}, {
  user: '@vibracion_radiestesia',
  text: 'Mis sesiones ahora tienen una estructura mucho más clara con los biómetros.',
  likes: 22,
  time: '6 días'
}, {
  user: '@alma_radiante',
  text: 'Recomendado para todos los niveles de práctica con el péndulo.',
  likes: 18,
  time: '6 días'
}, {
  user: '@paz_mental',
  text: 'El precio es un regalo para todo lo que trae.',
  likes: 53,
  time: '1 semana'
}, {
  user: '@energia_vital',
  text: 'Me encantaron los protocolos de diagnóstico.',
  likes: 13,
  time: '1 semana'
}, {
  user: '@terapeuta_online',
  text: 'Ideal para quienes trabajamos a distancia también.',
  likes: 27,
  time: '1 semana'
}, {
  user: '@radiestesia_vida',
  text: 'Las mediciones de frecuencia son muy potentes. Gracias!',
  likes: 20,
  time: '1 semana'
}, {
  user: '@sanacion_cuantica',
  text: 'Un material indispensable para cualquier terapeuta.',
  likes: 35,
  time: '2 semanas'
}, {
  user: '@yoga_energia_paz',
  text: 'Muy bien explicado y fácil de aplicar con los gráficos.',
  likes: 17,
  time: '2 semanas'
}, {
  user: '@maestra_radiestesia',
  text: 'Lo uso con mis alumnos y les encanta la claridad de los protocolos.',
  likes: 48,
  time: '2 semanas'
}, {
  user: '@vibras_positivas',
  text: 'El diseño de los materiales es hermoso.',
  likes: 12,
  time: '3 semanas'
}, {
  user: '@centro_holistico',
  text: 'Nos ahorró meses de trabajo en formularios y biómetros.',
  likes: 39,
  time: '3 semanas'
}, {
  user: '@radiestesia_terapeutica_pro',
  text: 'La mejor inversión que hice este año para mi consultorio.',
  likes: 61,
  time: '1 mes'
}, {
  user: '@luz_y_amor',
  text: 'Gracias por este kit tan maravilloso.',
  likes: 15,
  time: '1 mes'
}, {
  user: '@terapeuta_integral',
  text: 'Muy profesional y con mucha alma.',
  likes: 24,
  time: '1 mes'
}, {
  user: '@radiestesia_master_pro',
  text: 'Superó mis expectativas por completo.',
  likes: 45,
  time: '1 mes'
}, {
  user: '@energia_pura',
  text: 'Un material que todo radiestesista debería tener.',
  likes: 19,
  time: '1 mes'
}, {
  user: '@sanar_desde_adentro',
  text: 'Muy completo y fácil de entender.',
  likes: 22,
  time: '2 meses'
}, {
  user: '@radiestesia_argentina',
  text: 'Excelente relación calidad-precio.',
  likes: 33,
  time: '2 meses'
}];
export function Reviews() {
  const [comment, setComment] = useState('');
  const [rating, setRating] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [visibleCount, setVisibleCount] = useState(3);
  const handlePublish = () => {
    if (comment.trim()) {
      setShowPopup(true);
      setComment('');
      setRating(0);
    }
  };
  const loadMore = () => {
    setVisibleCount(prev => Math.min(prev + 5, ALL_REVIEWS.length));
  };
  return <section className="py-20 bg-violet-50 pt-[30px] pb-[30px]" data-id="element-320">
      <div className="max-w-3xl mx-auto px-4" data-id="element-321">
        <h2 className="text-violet-950 mb-10 text-center text-[32px] md:text-[48px] font-medium font-['Playfair_Display']" data-id="element-322">
          Comunidad de Radiestesia
        </h2>

        <div className="bg-white p-6 rounded-2xl border border-violet-100 mb-12 shadow-sm" data-id="element-323">
          <h3 className="text-violet-950 font-bold mb-4" data-id="element-324">
            Deja tu reseña para la comunidad:
          </h3>
          <textarea value={comment} onChange={e => setComment(e.target.value)} placeholder="Escribe aquí tu experiencia con el Kit..." className="w-full bg-violet-50 border border-violet-100 rounded-xl p-4 text-violet-950 focus:border-violet-400 outline-none transition-colors mb-4 min-h-[100px]" data-id="element-325" />
          <div className="flex flex-wrap items-center justify-between gap-4" data-id="element-326">
            <div className="flex items-center gap-2" data-id="element-327">
              <span className="text-violet-400 text-sm" data-id="element-328">Calificar:</span>
              <div className="flex gap-1" data-id="element-329">
                {[1, 2, 3, 4, 5].map(s => <button key={s} onClick={() => setRating(s)} className={`${rating >= s ? 'text-violet-600' : 'text-violet-200'} hover:scale-110 transition-transform`} data-id="element-330">
                    <Star size={20} fill={rating >= s ? 'currentColor' : 'none'} data-id="element-331" />
                  </button>)}
              </div>
            </div>
            <button onClick={handlePublish} className="bg-violet-950 text-white font-black px-8 py-3 rounded-full hover:bg-violet-800 transition-colors uppercase text-sm" data-id="element-332">
              Publicar
            </button>
          </div>
        </div>

        <div className="space-y-8" data-id="element-333">
          {ALL_REVIEWS.slice(0, visibleCount).map((rev, i) => <div key={i} className="border-b border-violet-100 pb-6" data-id="element-334">
              <div className="flex items-center justify-between mb-2" data-id="element-335">
                <span className="text-violet-600 font-bold text-sm" data-id="element-336">
                  {rev.user}
                </span>
                <div className="flex text-violet-600" data-id="element-337">
                  {[...Array(5)].map((_, i) => <Star key={i} size={12} fill="currentColor" data-id="element-338" />)}
                </div>
              </div>
              <p className="text-violet-900 mb-3" data-id="element-339">{rev.text}</p>
              <div className="flex items-center gap-4 text-xs text-violet-400" data-id="element-340">
                <button className="flex items-center gap-1 hover:text-violet-600 transition-colors" data-id="element-341">
                  <Heart size={14} data-id="element-342" /> {rev.likes} Likes
                </button>
                <span data-id="element-343">hace {rev.time}</span>
              </div>
            </div>)}
          {visibleCount < ALL_REVIEWS.length && <button onClick={loadMore} className="w-full py-4 text-violet-400 font-bold hover:text-violet-600 transition-colors uppercase text-sm tracking-widest" data-id="element-344">
              Cargar 5 comentarios más
            </button>}
        </div>
      </div>

      <AnimatePresence data-id="element-345">
        {showPopup && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-violet-950/40 backdrop-blur-sm" data-id="element-346">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} className="bg-white border-2 border-violet-600 p-8 rounded-3xl max-w-sm w-full text-center shadow-2xl" data-id="element-347">
              <div className="w-16 h-16 bg-violet-600 rounded-full flex items-center justify-center mx-auto mb-4 text-white" data-id="element-348">
                <CheckCircle2 size={32} data-id="element-349" />
              </div>
              <h4 className="text-xl font-black text-violet-950 mb-2" data-id="element-350">
                ¡Gracias por tu comentario!
              </h4>
              <p className="text-violet-800/60 mb-6" data-id="element-351">
                Tu opinión ayuda a la comunidad.
              </p>
              <button onClick={() => setShowPopup(false)} className="w-full bg-violet-950 text-white font-black py-3 rounded-xl uppercase text-sm" data-id="element-352">
                Cerrar
              </button>
            </motion.div>
          </div>}
      </AnimatePresence>
    </section>;
}